import {Component, Input, Output, EventEmitter} from '@angular/core';
import {MdDialogRef} from '@angular/material';
import {SurveyManagementService} from '../survey-management.service';
import {SurveyResponse} from '../../../shared/models/survey/survey-response.model';
import {TrackingService} from '../../../shared/services/tracking/google-analytics-events.service';
import {TrackingConstants} from '../../../shared/services/tracking/tracking-constants.service';
import {SnackBarService} from '../../../services/snackbar.service';
import {MessageService} from '../../../services/messages.service';
import {SurveyQuestionType} from '../../../shared/models/survey/survey-question-type.enum';
import {SurveyQuestion} from '../../../shared/models/survey/survey-question.model';

@Component({
  selector: 'survey-response-list',
  templateUrl: './survey-response-list.component.html'
})
export class SurveyResponseListComponent{

  @Input()
  surveyResponses: SurveyResponse[];
  @Input()
  selectedSurveyQuestion: SurveyQuestion;
  @Input()
  action: String;
  @Input()
  textQuestions: SurveyQuestion[];
  @Output()
  responseClear: EventEmitter<any> = new EventEmitter();
  SurveyQuestionType: typeof SurveyQuestionType = SurveyQuestionType;
  questionListVisible: boolean;
  targetQuestion: SurveyQuestion;

  constructor(
    private surveyManagementService: SurveyManagementService,
    public dialogRef: MdDialogRef<any>,
    private trackingService: TrackingService,
    private snackBarService: SnackBarService
  ){}

  getResponseText(response: SurveyResponse) {
      if (response.optionAnswer !== -1) {
        return response.options.find(op => op.id === response.optionAnswer).optionText;
      } else if (response.openAnswer) {
        return response.openAnswer;
      } else if (response.responseOrganisation) {
        return response.responseOrganisation.name;
      } else if (response.responsePerson) {
        return response.responsePerson.callingName;
      }
  }

  clearAllResponses() {
    this.surveyManagementService.clearSurveyResponse(this.surveyResponses.map(sr => sr.id)).subscribe(response => {
      this.proceedDelete(response, TrackingConstants.CLEAR_SURVEY_QUESTION_RESPONSE);
    });
  }

  moveResponseOptionVisible(): boolean {
    return this.textQuestions.length > 0 && this.selectedSurveyQuestion
      && this.selectedSurveyQuestion.questionType.toString() === SurveyQuestionType[SurveyQuestionType.PARAGRAPH_TEXT];
  }

  setQuestionListVisible(isVisible: boolean) {
    this.questionListVisible = isVisible;
    if (!isVisible) {
      this.targetQuestion = null;
    }
  }

  moveResponse() {
    this.surveyManagementService.moveTextResponse(this.selectedSurveyQuestion.id, this.targetQuestion.id).subscribe(response => {
      this.proceedDelete(response, TrackingConstants.MOVE_SURVEY_QUESTION_RESPONSE);
    });
  }

  private proceedDelete(response, event) {
    if (response.flagResult) {
      this.responseClear.emit();
      this.trackingService
        .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT, event,
          TrackingConstants.SUCCESS, 1);
      let msg = MessageService.CLEAR_SURVEY_QUESTION_RESPONSE_SUCCESS;
      if (this.action === "Delete") {
        msg += MessageService.DELETE_QUESTION;
      } else {
        msg += MessageService.REMOVE_OPTIONS;
      }
      this.snackBarService
        .showStatus(response, msg, MessageService.CLEAR_SURVEY_QUESTION_RESPONSE_FAILURE);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/survey/response/survey-response-list.component.ts